import { Field as HField, Label, Radio, RadioGroup as HRadioGroup } from '@headlessui/react';

export interface RadioOption<T extends string> {
    value: T;
    label: string;
    disabled?: boolean;
}

export interface RadioGroupProps<T extends string> {
    value: T;
    onChange: (value: T) => void;
    options: RadioOption<T>[];
    'aria-label': string;
}

export function RadioGroup<T extends string>({ value, onChange, options, ...rest }: RadioGroupProps<T>) {
    return (
        <HRadioGroup value={value} onChange={onChange} aria-label={rest['aria-label']} className="flex flex-col">
            {options.map((o) => (
                <HField key={o.value} disabled={o.disabled} className="flex min-h-control cursor-pointer items-center gap-3 data-[disabled]:opacity-60">
                    <Radio
                        value={o.value}
                        className="group flex size-5 shrink-0 items-center justify-center rounded-chip border-[1.5px] border-line-strong bg-surface data-[checked]:border-inverse data-[checked]:bg-inverse"
                    >
                        <span className="hidden size-2 rounded-chip bg-on-inverse group-data-[checked]:block" />
                    </Radio>
                    <Label className="cursor-pointer text-small text-strong">{o.label}</Label>
                </HField>
            ))}
        </HRadioGroup>
    );
}
